exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selectBorder[data-v-3ab78f30]  .el-input__inner{border:none}.selectBorder input[data-v-3ab78f30]::-webkit-input-placeholder{color:red}.selectBorder input[data-v-3ab78f30]::-moz-placeholder{color:red}.selectBorder input[data-v-3ab78f30]:-ms-input-placeholder{color:red}.selectBorder input[data-v-3ab78f30]::-ms-input-placeholder{color:red}.selectBorder input[data-v-3ab78f30]::placeholder{color:red}.test[data-v-3ab78f30]  .el-radio-button__inner{background:none;border:none;color:red}", ""]);

// exports
